export enum DRAWER_VIEWS {
  Login = 'Login',
  PhotoDrawer = 'PhotoDrawer',
}

export enum DRAWER_POSITIONS {
  Left = 'Left',
  Right = 'Right',
}

export const DRAWER_DEFAULT_VALUES = {
  drawerView: DRAWER_VIEWS.PhotoDrawer,
  drawerPosition: DRAWER_POSITIONS.Left,
  drawerVisible: false,
  withBackdrop: true,
  drawerData: undefined,
  openPoint: '',
};

export interface OpenDrawerParams {
  drawerView?: DRAWER_VIEWS;
  drawerPosition?: DRAWER_POSITIONS;
  withBackdrop?: boolean;
  uploadButtonCallback?: () => void;
  drawerData?: any;
  openPoint?: string;
}
